import { Checkbox, Tooltip, Typography, WithInfoIcon } from 'seagull';
import ConditionalWrapper from "../ConditionalWrapper/ConditionalWrapper";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AllowManualPaymentsCheckbox(props) {
  const {
    value,
    isSampleRelationship = false,
    isReadOnly,
    onChange
  } = props;
  return /*#__PURE__*/_jsx(WithInfoIcon, {
    info: "Select if your client prefers to manually approve each payment, rather than have payments processed automatically.",
    children: /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: isSampleRelationship,
      wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            skin: "invertedStandard",
            weight: "bold",
            children: "Testing Mode Disables Payments"
          }), /*#__PURE__*/_jsx(Typography, {
            skin: "invertedStandard",
            children: "When creating a proposal with a sample client, this option is disabled. No payment will be processed or saved when you send it, so you can interact with it freely."
          })]
        }),
        children: /*#__PURE__*/_jsx("div", {
          children: children
        })
      }),
      children: /*#__PURE__*/_jsx(Checkbox, {
        "data-testid": "agreement-studio-allow-manual-payments-Checkbox",
        checked: value && !isSampleRelationship,
        disabled: isSampleRelationship || isReadOnly,
        onChange: function (_onChange) {
          function onChange() {
            return _onChange.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange.toString();
          };
          return onChange;
        }(() => onChange(!value)),
        children: /*#__PURE__*/_jsx(Typography, {
          skin: isSampleRelationship ? 'disabled' : 'standard',
          children: "Let my client manually approve each payment"
        })
      })
    })
  });
}